import escapeRegExp from 'escape-string-regexp'

export function escapeStringToMatchWord(str) {
  return new RegExp(escapeRegExp(str));
}